import BaseService from "./BaseService";
import _ from "lodash";
import { decamelizeKeys } from "humps";
import { fetchPatientQueueToken } from "../helpers/patient_queue_token";
import { handleApiError, handleApiResponse } from "../helpers/visuwell";
import { objectToQueryString } from "../helpers/object";

export default {
  login(jwt, redirectUrl, encodeJwt = true) {
    let urlParts = redirectUrl.split("/");
    let loginUrl = [urlParts[0], "//", urlParts[2]].join("");
    let uriToken = null;
    if (encodeJwt) {
      uriToken = encodeURIComponent(btoa(jwt));
    } else {
      uriToken = jwt;
    }

    return new Promise(function (resolve, _reject) {
      resolve(`${loginUrl}/sessions/jwt_authenticate/${uriToken}`);
    });
  },

  createUser(params) {
    let userParams = decamelizeKeys(params);
    let token = fetchPatientQueueToken();

    return BaseService.post(`visuwell/users`, {
      token,
      ...userParams,
    })
      .then(handleApiResponse)
      .catch(handleApiError);
  },

  findUser(params) {
    let userParams = decamelizeKeys(params);
    let token = fetchPatientQueueToken();
    let queryStr = objectToQueryString({
      token,
      ...userParams,
    });
    console.log("queryStr=", queryStr);
    return BaseService.get(`visuwell/users?${queryStr}`)
      .then(handleApiResponse)
      .catch(handleApiError);
  },

  startOnDemandSession(interviewId, params) {
    let token = fetchPatientQueueToken();

    return BaseService.post(`visuwell/start_on_demand_session`, {
      patient_queue_id: params["patientQueueId"],
      organization_location: params["organizationLocationId"],
      interview_id: interviewId,
      token,
    })
      .then(handleApiResponse)
      .catch(handleApiError);
  },
};
